 /**
 * 
 * Maps
 * 
 */

function initMap() {

  var locations = []; 
  var mapMarlers = document.getElementsByClassName("map-marker");
  
  for (var i = 0; i < mapMarlers.length; i++) {

      locations.push( [ mapMarlers[i].dataset.name , parseFloat(mapMarlers[i].dataset.lat), parseFloat(mapMarlers[i].dataset.lng) ] ); 
  } 

  var center = {lat: locations[0][1], lng: locations[0][2]};

  var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 9,
      center: center,
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false
    });

  var infowindow =  new google.maps.InfoWindow({});

  var marker, count;

  for (count = 0; count < locations.length; count++) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(locations[count][1], locations[count][2]),
        map: map,
        title: locations[count][0]
      });

      google.maps.event.addListener(marker, 'click', (function (marker, count) {
            return function () {
              infowindow.setContent(locations[count][0]);
              infowindow.open(map, marker);
            }
          })(marker, count));
  }

}


var isMap = document.getElementById("map");

if(isMap != null) { 
  initMap();
}




